import React, { FunctionComponent } from 'react';
import { View, Text } from '@react-pdf/renderer';
import type { FormattedItem } from '../../../types';
import { STYLES } from '../../constants';
import useLineItemValues from './useLineItemValues';

export interface LineItemProps {
  lineItem: FormattedItem;
}

const LineItem: FunctionComponent<LineItemProps> = function ({ lineItem }) {
  const { quantity, title, description, price, vat, total } =
    useLineItemValues(lineItem);

  const ViewTag = View as unknown as FunctionComponent<any>;
  const TextTag = Text as unknown as FunctionComponent<any>;

  return (
    <ViewTag style={STYLES.lineItem}>
      <TextTag
        style={{
          ...STYLES['text-12-18'],
          ...STYLES['text-neutral-600'],
          ...STYLES.lineDetailSmall,
          ...STYLES.quantity,
        }}
      >
        {quantity}
      </TextTag>
      <ViewTag
        style={{
          ...STYLES.column,
          ...STYLES.title,
        }}
      >
        <TextTag
          style={{
            ...STYLES['text-14-22-em'],
            ...STYLES['text-neutral-700'],
          }}
        >
          {title}
        </TextTag>
        {description && (
          <TextTag
            style={{
              ...STYLES['text-12-18'],
              ...STYLES['text-neutral-600'],
              ...STYLES.mt1,
            }}
          >
            {description}
          </TextTag>
        )}
      </ViewTag>
      <TextTag
        style={{
          ...STYLES['text-12-18'],
          ...STYLES['text-neutral-600'],
          ...STYLES.lineDetailSmall,
          ...STYLES.price,
        }}
      >
        {price}
      </TextTag>
      <TextTag
        style={{
          ...STYLES['text-12-18'],
          ...STYLES['text-neutral-600'],
          ...STYLES.lineDetailSmall,
          ...STYLES.vat,
        }}
      >
        {vat}
      </TextTag>
      <TextTag
        style={{
          ...STYLES['text-16-20-em'],
          ...STYLES['text-neutral-500'],
          ...STYLES.total,
        }}
      >
        {total}
      </TextTag>
    </ViewTag>
  );
};

export default LineItem;
